import React from "react";
import { getFormattedNumber } from "../../../generic/PageUI/Basic/Metric/utils";
import ChrWidgetActions from "../../../generic/PageUI/Basic/Widget/ChrWidgetActions";
import ChrLink from "../../../generic/Utils/ChrLink";
import { mergeProps } from "../../../generic/Utils/mergeProps";

/*
props = {
  title: <string>,
  url: <URL>,
  value: <string>, // optional,
  titleSuffix: <component> // optional,
  wrapperOptions: <object> // optional,
  actions: <params for ChrWidgetActions> // optional
}
*/

const Card = (props) => {
  const { value, title, url, titleSuffix, actions = {}, wrapperOptions = {}, paddingOptions = { className: "py-3" }, linkOptions = {}, titleOptions = {} } = props;
  const { valueToDisplay, isANumber } = getFormattedNumber(value);
  const allWrapperOptions = mergeProps({ className: "d-flex" }, wrapperOptions, paddingOptions)
  const chrLinkOptions = mergeProps({ className: "d-flex", href: url, newTab: true }, linkOptions)

  return (
    <div {...allWrapperOptions}>
      <div className="flex-1">
        <ChrLink {...chrLinkOptions}>
          <div className='d-flex align-items-center pr-3'>
            <span {...titleOptions}>{title}</span>
            {titleSuffix}
          </div>
        </ChrLink>
      </div>
      {
        isANumber &&
        <ChrLink {...chrLinkOptions}>
          <div className={ `no-padding text-right align-self-center font-600 ${props.valueClass}` }>{ valueToDisplay }</div>
        </ChrLink>
      }
      <ChrWidgetActions actions={actions} />
    </div>
  )
}

export default Card;
